import React from 'react';
import styled from 'styled-components';
import { Icon } from '../../../components';

const TagFeaturedStyled = styled.div`
  background-color: var(--background-tag-background07);
  color: var(--background-tag-background08);
  width: fit-content;
  padding: 4px 12px;
  border-radius: 20px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: 4px;

  cc-icon {
    // margin-right: 4px;
  }
`;

const TagFeatured = ({
  isCard,
  style
}: {
  isCard?: boolean;
  style?: React.CSSProperties;
}) => (
  <TagFeaturedStyled style={style}>
    <Icon name="star-filled" size={20} />
    {!isCard && 'Destacado'}
  </TagFeaturedStyled>
);

TagFeatured.defaultProps = {
  isCard: false
};

export default TagFeatured;
